import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isLogin: false,
  loading: true,   // important for SSR hydration
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isLogin = !!action.payload;
      state.loading = false;
      state.error = null;
    },

    logout: (state) => {
      state.user = null;
      state.isLogin = false;
      state.loading = false;
      state.error = null;
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setUser,
  logout,
  setLoading,
  setError,
} = authSlice.actions;

export default authSlice.reducer;
